// Material Dashboard 2 PRO React layouts
import SettingsRec from "layouts/recruitement/settings";
import Candidates from "layouts/recruitement/candidates";
import Screening from "layouts/recruitement/screening";
import Analytics from "layouts/dashboards/analytics";
import Sales from "layouts/dashboards/sales";
import ProfileOverview from "layouts/pages/profile/profile-overview";
import Settings from "layouts/pages/account/settings";
import SignInBasic from "layouts/authentication/sign-in/basic";
import SignInCover from "layouts/authentication/sign-in/cover";
import SignInIllustration from "layouts/authentication/sign-in/illustration";
import ResetCover from "layouts/authentication/reset-password/cover";
// import Attendance from "layouts/dashboards/attendance";
import Attendance from "layouts/attendance";
import Employees from "layouts/employees";
import { WorkFromHome } from "layouts/workFromHome/index";
// Material Dashboard 2 PRO React components
import MDAvatar from "components/MDAvatar";
import OTP from "layouts/authentication/otp";
import Kanban from "layouts/applications/kanban";
import Wizard from "layouts/applications/wizard";
import Calendar from "layouts/applications/calendar";

// @mui icons
import Icon from "@mui/material/Icon";
import Recruitement from "layouts/recruitement";
// Images
import profilePicture from "assets/images/team-3.jpg";
import { Navigate } from "react-router-dom";
import OrganisationSignUp from "layouts/authentication/org-sign-up";
import BasicInfo from "layouts/pages/account/settings/components/BasicInfo";

import Interviews from "layouts/recruitement/interview";
import Shifts from "layouts/attendance/shifts";
import ApproveLeave from "layouts/managerdesk/approveLeave";
import DailyStatus from "layouts/managerdesk/dailyStatus";
import Teamfeedback from "layouts/managerdesk/teamFeedback";
import ApproveWFH from "layouts/managerdesk/approveWFH";
// import Invoice from "layouts/pages/account/invoice";
import Billing from "layouts/invoicing/billing";
import Invoice from "layouts/invoicing/invoice";
import PricingPage from "layouts/invoicing/pricing_page";
import UploadAttendance from "layouts/attendance/uploadAttendance";
import EmployeeView from "layouts/employees/employee_view";
import { Leaves } from "layouts/leaves";
import { AttendanceSettings } from "layouts/attendance/settings";
import { OrganisationSettings } from "layouts/settings/organisation_settings";
import { LeaveSettings } from "layouts/leaves/settings";
import SubscriptionPayment from "layouts/invoicing/pricing_page/components/SubscriptonPayment";
import JobOffer from "layouts/recruitement/jobOffer";
import EmployeeDashboard from "layouts/dashboards/employee_dashboard";
import NewEvent from "layouts/marketing/newEvent";
import { Payrole } from "layouts/payrole";
import Holidays from "layouts/holidays";

import list from "assets/theme/components/list";

import FormBuilder from "layouts/marketing/FormBuilder";
import { GeneratePayrole } from "layouts/payrole/generatePayrole";
import CurrentOpenings from "layouts/recruitement/currentOpenings";
import { Dashboard } from "layouts/dashboards";
import { EmployeeEvents } from "layouts/marketing/employeeEvents";
import { AllAttendance } from "layouts/attendance/allAttendance";
import { Contracts } from "layouts/payrole/contracts";
import { Salary } from "layouts/payrole/salary";
import { Expenses } from "layouts/payrole/expenses";
import { Batch } from "layouts/payrole/batch";
import { TempCard } from "layouts/employees/temp_card";
import { ApproveMissPunch } from "layouts/attendance/approveMissPunch";
import PayroleTabs from "layouts/payrole/PayroleTabs";
import SalaryBatches from "layouts/payrole/salaryBatches";
import Position from "layouts/recruitement/currentOpenings/position";
import Recuritement from "layouts/recruitement/recruitementData";
import HiringFlows from "layouts/recruitement/setting";
import ApproveLeaveTabs from "layouts/managerdesk/approveLeave/approveLeaveTabs";

const routes = [
  {
    type: "collapse",
    name: "Current User",
    key: "currentUser",

    collapse: [
      {
        name: "My Profile",
        key: "Employee",
        permissionKey: "employee",
        route: "/pages/profile/profile-overview",
        icon: <Icon fontSize="medium">account_circle</Icon>,
        component: <EmployeeView />,
        not_found_component: <Navigate to="/not_found" />,
        permission_denied_component: <Navigate to="/permission_denied" />,
        requireRole: false,
        modulePermissions: {
          owner_list_permission: "employee | employee|owner_list",
          list_permission: "employee | employee|list",
          create_permission: "employee | employee|create",
          delete_permission: "employee | employee|delete",
          update_permission: "employee | employee|update",
          reporting_structure_owner_list_permission: "employee | reporting structure|owner_list",
          reporting_structure_list_permission: "employee | reporting structure|list",
          reporting_structure_update_permission: "employee | reporting structure|update",
          reporting_structure_create_permission: "employee | reporting structure|create",
          reporting_structure_delete_permission: "employee | reporting structure|delete",
          leave_balance_list_permission: "leave | leave balance|list",
          leave_balance_owner_list_permission: "leave | leave balance|owner_list",
          leave_balance_create_permission: "leave | leave balance|create",
          leave_balance_udpate_permission: "leave | leave balance|update",


        },
      },
      {
        name: "Logout",
        key: "logout",
        route: "/authentication/sign-in/illustration",
        component: <SignInIllustration />,
        icon: <Icon fontSize="medium">logout</Icon>,

        not_found_component: <Navigate to="/not_found" />,
        permission_denied_component: <Navigate to="/permission_denied" />,
        requireRole: false,
      },
    ],
  },
  {
    type: "open",
    name: "Settings",
    key: "settings",
    collapse: [
      {
        name: "Basic Info",
        key: "BasicInfo",
        route: "/pages/account/settings/components/BasicInfo",
        component: <BasicInfo />,
        not_found_component: <Navigate to="/not_found" />,
        permission_denied_component: <Navigate to="/permission_denied" />,
        requireRole: false,
      },
    ],
  },

	//{
  //  type: "header",
  //  name: "Recruitment",
  //  key: "recruitment",
  //  permissionKey: "recruitment",
  //  icon: <Icon fontSize="medium">corporate_fare</Icon>, // Replace with your icon
  //  displayOnly: true, // Indicates no dropdown
  //  route: "/recruitement/:tab", // Define the route path
  //  component: <Recuritement />, // The component to render
  //  not_found_component: <Navigate to="/not_found" />,
  //  permission_denied_component: <Navigate to="/permission_denied" />,
  //},
  {
    type: "header",
    name: "Dashboards",
    key: "dashboards",
    permissionKey: "notifications",
    icon: <Icon fontSize="medium">dashboard</Icon>,
    displayOnly: true,
    route: "/dashboards/dashboard",
    // requireRole: true,
    modulePermissions: {
      notification_create_permission: "notifications | notishboard|create"
    },
    component: <Dashboard />,
    not_found_component: <Navigate to="/not_found" />,
    permission_denied_component: <Navigate to="/permission_denied" />,
  },


  // Employee Routes
  {
    type: "collapse",
    name: "Employee",
    key: "employee",
    icon: <Icon fontSize="medium">group</Icon>,
    collapse: [
      {
        name: "Employees",
        key: "employees",
        permissionKey: "employee",
        route: "/employee/employees",
        icon: <Icon fontSize="medium">groups</Icon>,
        requireRole: true,
        modulePermissions: {
          list_permission: "employee | employee|list",
          own_list_permission: "employee | employee|owner_list",
          create_permission: "employee | employee|create",
          delete_permission: "employee | employee|delete",
          update_permission: "employee | employee|update",
        },
        component: <Employees />,
        not_found_component: <Navigate to="/not_found" />,
        permission_denied_component: <Navigate to="/permission_denied" />,
      },
      {
        name: "Leaves",
        key: "Leaves",
        permissionKey: "leave",
        route: "/Leaves",
        icon: <Icon fontSize="medium">touch_app</Icon>,
        requireRole: true,
        modulePermissions: {
          own_list_permission: "leave | leave request|owner_list",
          list_permission: "leave | leave request|list",
          create_permission: "leave | leave request|create",
          update_permission: "leave | leave request|update",
          delete_permission: "leave | leave request|delete",
          leave_admin_permission: "leave | leave request|leave_admin",
          balance_list_permission: "leave | leave balance|list",
          balance_admin_permission: "leave | leave balance|leave_admin",
          balance_create_permission: "leave | leave balance|create",
          balance_update_permission: "leave | leave balance|update",
          balance_delete_permission: "leave | leave balance|delete",
          transaction_owner_list_permission: "leave | leave transaction|owner_list",
          transaction_list_permission: "leave | leave transaction|list",
          transaction_admin_permission: "leave | leave transaction|leave_admin",
          transaction_create_permission: "leave | leave transaction|create",
          transaction_update_permission: "leave | leave transaction|update",
          transaction_delete_permission: "leave | leave transaction|delete",
          approval_admin_permission: "leave | leave request approval|leave_admin",
          approval_list_permission: "leave | leave request approval|list",
        },
        component: <Leaves />,
        not_found_component: <Navigate to="/not_found" />,
        permission_denied_component: <Navigate to="/permission_denied" />,
      },
    //   {
    // type: "collapse",
    // name: "Holidays",
    // key: "Holidays",
    // icon: <Icon fontSize="medium">cottage</Icon>,
    // collapse: [
      {
        name: "Holidays",
        key: "Holidays",
        permissionKey: "holiday",
        icon: <Icon fontSize="medium">photo_size_select_actual</Icon>,
        route: "/Holidays",
        requireRole: true,
        modulePermissions: {
          list_permission: "holiday | holiday|list",
          create_permission: "holiday | holiday|create",
          delete_permission: "holiday | holiday|delete",
          update_permission: "holiday | holiday|update",
        },
        component: <Holidays />,

        not_found_component: <Navigate to="/not_found" />,
        permission_denied_component: <Navigate to="/permission_denied" />,
      },
  //   ],
  // },
      {
        name: "Attendance",
        key: "Attendance",
        permissionKey: "attendance",
        route: "/Attendance",
        icon: <Icon fontSize="medium">fingerprint_sharp</Icon>,
        requireRole: true,
        modulePermissions: {
          own_list_permission: "attendance | Employee Attendence|owner_list",
          list_permission: "attendance | Employee Attendence|list",
          create_permission: "attendance | Employee Attendence|create",
          update_permission: "attendance | Employee Attendence|update",
          delete_permission: "attendance | Employee Attendence|delete",
        },
        component: <Attendance />,
        not_found_component: <Navigate to="/not_found" />,
        permission_denied_component: <Navigate to="/permission_denied" />,
      },
	//		{
	//			name: "Kanban",
	//			key: "kanban",
	//			route: "/applications/kanban",
	//			requireRole: false,
	//			icon: <Icon fontSize="medium">receipt_long</Icon>,
	//			component: <Kanban />,
	//			not_found_component: <Navigate to="/not_found" />,
	//			permission_denied_component: <Navigate to="/permission_denied" />,
	//		},
	//		{
  //      name: "Daily Status",
  //    key: "daily-status",
  //   icon: <Icon fontSize="medium">pix_sharp</Icon>,
  //   route: "/layouts/managerdesk/dailyStatus",
  //      requireRole: false,
  //       component:<DailyStatus/>,
  //       not_found_component: <Navigate to="/not_found" />,
  //       permission_denied_component: <Navigate to="/permission_denied" />,
  //},
      {
        name: "Work From Home",
        key: "Work From Home",
        permissionKey: "attendance",
        route: "/WorkFromHome",
        icon: <Icon fontSize="medium">home_work</Icon>,
        requireRole: true,
        modulePermissions: {
          own_list_permission: "attendance | Employee Attendence|owner_list",
          list_permission: "attendance | Employee Attendence|list",
          create_permission: "attendance | Employee Attendence|create",
          update_permission: "attendance | Employee Attendence|update",
          delete_permission: "attendance | Employee Attendence|delete",
        },
        component: <WorkFromHome />,
        not_found_component: <Navigate to="/not_found" />,
        permission_denied_component: <Navigate to="/permission_denied" />,
      },


      // {
      //   name: "Temp Card",
      //   key: "temp_card",
      //   permissionKey: "employee",
      //   route: "/employee/temp_card",
      //   icon: <Icon fontSize="medium">credit_card</Icon>,
      //   requireRole: false,
      //    modulePermissions: {
      //      list_permission: "employee | employee|list",
      //      own_list_permission: "employee | employee|owner_list" ,
      //      create_permission: "employee | employee|create",
      //      delete_permission: "employee | employee|delete",
      //      update_permission: "employee | employee|update",
      //    },
      //   component: <TempCard />,
      //   not_found_component: <Navigate to="/not_found" />,
      //   permission_denied_component: <Navigate to="/permission_denied" />,
      // },
    ]
  },

	// Recruitement Routes
  {
    type: "header",
    name: "Recruitment",
    key: "recruitment",
    permissionKey: "recruitment",
    icon: <Icon fontSize="medium">corporate_fare</Icon>, // Replace with your icon
    displayOnly: true, // Indicates no dropdown
    route: "/recruitement/:tab", // Define the route path
    modulePermissions: {
      jobAdvertisement: {
        own_list_permission: "recruitment | job advertisement|owner_list",
        list_permission: "recruitment | job advertisement|list",
        view_permission: "recruitment | job advertisement|view",
        create_permission: "recruitment | job advertisement|create",
        update_permission: "recruitment | job advertisement|update",
        delete_permission: "recruitment | job advertisement|delete",
      },

      screening: {
        own_list_permission: "recruitment | screening|owner_list",
        list_permission: "recruitment | screening|list",
        view_permission: "recruitment | screening|view",
        create_permission: "recruitment | screening|create",
        update_permission: "recruitment | screening|update",
        delete_permission: "recruitment | screening|delete",
      },

      candidate: {
        own_list_permission: "recruitment | candidate|owner_list",
        list_permission: "recruitment | candidate|list",
        view_permission: "recruitment | candidate|view",
        create_permission: "recruitment | candidate|create",
        update_permission: "recruitment | candidate|update",
        delete_permission: "recruitment | candidate|delete",
        owner_interview_list_permission: "recruitment | interview|owner_list",
        interview_list_permission: "recruitment | interview|list",
        interview_create_permission: "recruitment | interview|create",
        interview_update_permission: "recruitment | interview|update",
        interview_delete_permission: "recruitment | interview|delete",
      },
      interview: {
        list_permission: "recruitment | interview|list",
        view_permission: "recruitment | interview|view",
        own_list_permission: "recruitment | interview|owner_list",
        create_permission: "recruitment | interview|create",
        update_permission: "recruitment | interview|update",
        delete_permission: "recruitment | interview|delete",
      },
      jobOffer: {
        list_permission: "recruitment | job offer|list",
        view_permission: "recruitment | job offer|view",
        own_list_permission: "recruitment | job offer|owner_list",
        create_permission: "recruitment | job offer|create",
        update_permission: "recruitment | job offer|update",
        delete_permission: "recruitment | job offer|delete",
      },
      setting: {
        own_list_permission: "recruitment | hiring stage|owner_list",
        list_permission: "recruitment | hiring stage|list",
        view_permission: "recruitment | hiring stage|view",
        create_permission: "recruitment | hiring stage|create",
        update_permission: "recruitment | hiring stage|update",
        delete_permission: "recruitment | hiring stage|delete",
        owner_subStage_list_permission: "recruitment | hiring sub stage|owner_list",
        subStage_list_permission: "recruitment | hiring sub stage|list",
        subStage_create_permission: "recruitment | hiring sub stage|create",
        subStage_update_permission: "recruitment | hiring sub stage|update",
        subStage_delete_permission: "recruitment | hiring sub stage|delete",
        subStage_view_permission: "recruitment | hiring sub stage|view",
      }
    },
    component: <Recuritement />, // The component to render
    not_found_component: <Navigate to="/not_found" />,
    permission_denied_component: <Navigate to="/permission_denied" />,
  },

  {
    type: "open",
    name: "Current Openings",
    key: "Job_Advertisement",
    permissionKey: "recruitment",
    // route: "/recruitement/Job_Advertisement",
    // icon: <Icon fontSize="medium">featured_video</Icon>,
    requireRole: true,
    modulePermissions: {
      own_list_permission: "recruitment | job advertisement|owner_list",
      list_permission: "recruitment | job advertisement|list",
      view_permission: "recruitment | job advertisement|view",
      create_permission: "recruitment | job advertisement|create",
      update_permission: "recruitment | job advertisement|update",
      delete_permission: "recruitment | job advertisement|delete",
    },
    // component: <CurrentOpenings />,
    not_found_component: <Navigate to="/not_found" />,
    permission_denied_component: <Navigate to="/permission_denied" />,
  },
  {
    type: "open",
    name: "Screening",
    key: "Screening",
    permissionKey: "recruitment",
    route: "/recruitement/Screening",
    icon: <Icon fontSize="medium">portrait</Icon>,
    requireRole: true,
    modulePermissions: {
      own_list_permission: "recruitment | screening|owner_list",
      list_permission: "recruitment | screening|list",
      view_permission: "recruitment | screening|view",
      create_permission: "recruitment | screening|create",
      update_permission: "recruitment | screening|update",
      delete_permission: "recruitment | screening|delete",
    },
    component: <Screening />,
    not_found_component: <Navigate to="/not_found" />,
    permission_denied_component: <Navigate to="/permission_denied" />,
  },
  {
    type: "open",
    name: "Candidate",
    key: "Candidate",
    permissionKey: "recruitment",
    route: "/recruitement/Candidate",
    icon: <Icon fontSize="medium">group</Icon>,
    requireRole: true,
    component: <Candidates />,
    modulePermissions: {
      own_list_permission: "recruitment | candidate|owner_list",
      list_permission: "recruitment | candidate|list",
      view_permission: "recruitment | candidate|view",
      create_permission: "recruitment | candidate|create",
      update_permission: "recruitment | candidate|update",
      delete_permission: "recruitment | candidate|delete",
      owner_interview_list_permission: "recruitment | interview|owner_list",
      interview_list_permission: "recruitment | interview|list",
      interview_create_permission: "recruitment | interview|create",
      interview_update_permission: "recruitment | interview|update",
      interview_delete_permission: "recruitment | interview|delete",
    },
    not_found_component: <Navigate to="/not_found" />,
    permission_denied_component: <Navigate to="/permission_denied" />,
  },
  {
    type: "open",
    name: "Interviews",
    key: "Interview",
    permissionKey: "recruitment",
    route: "/recruitement/Interview",
    icon: <Icon fontSize="medium">portrait</Icon>,
    requireRole: true,
    modulePermissions: {
      list_permission: "recruitment | interview|list",
      view_permission: "recruitment | interview|view",
      own_list_permission: "recruitment | interview|owner_list",
      create_permission: "recruitment | interview|create",
      update_permission: "recruitment | interview|update",
      delete_permission: "recruitment | interview|delete",
    },
    component: <Interviews />,
    not_found_component: <Navigate to="/not_found" />,
    permission_denied_component: <Navigate to="/permission_denied" />,
  },
  {
    type: "open",
    name: "Job Offers",
    key: "JobOffers",
    permissionKey: "recruitment",
    route: "/recruitement/JobOffers",
    icon: <Icon fontSize="medium">work</Icon>,
    requireRole: true,
    modulePermissions: {
      list_permission: "recruitment | job offer|list",
      view_permission: "recruitment | job offer|view",
      own_list_permission: "recruitment | job offer|owner_list",
      create_permission: "recruitment | job offer|create",
      update_permission: "recruitment | job offer|update",
      delete_permission: "recruitment | job offer|delete",
    },
    component: <JobOffer />,
    not_found_component: <Navigate to="/not_found" />,
    permission_denied_component: <Navigate to="/permission_denied" />,
  },
  {
    type: "open",
    name: "setting",
    key: "setting",
    permissionKey: "recruitment",
    route: "/recruitement/hiring_flows",
    requireRole: true,
    // icon: <Icon fontSize="medium">work</Icon>,
    modulePermissions: {
      own_list_permission: "recruitment | hiring stage|owner_list",
      list_permission: "recruitment | hiring stage|list",
      view_permission: "recruitment | hiring stage|view",
      create_permission: "recruitment | hiring stage|create",
      update_permission: "recruitment | hiring stage|update",
      delete_permission: "recruitment | hiring stage|delete",
      owner_subStage_list_permission: "recruitment | hiring sub stage|owner_list",
      subStage_list_permission: "recruitment | hiring sub stage|list",
      subStage_create_permission: "recruitment | hiring sub stage|create",
      subStage_update_permission: "recruitment | hiring sub stage|update",
      subStage_delete_permission: "recruitment | hiring sub stage|delete",
      subStage_view_permission: "recruitment | hiring sub stage|view",
    },
    component: <HiringFlows />,
    not_found_component: <Navigate to="/not_found" />,
    permission_denied_component: <Navigate to="/permission_denied" />,
  },
  {
    type: "open",
    name: "Salary Batches",
    key: "salaryBatches",
    route: "/payroll/payrollBatches",
    requireRole: false,
    component: <SalaryBatches />,
    not_found_component: <Navigate to="/not_found" />,
    permission_denied_component: <Navigate to="/permission_denied" />,
  },
  {
    type: "open",
    name: "Batch",
    key: "batch",
    route: "/payroll/batch",
    requireRole: false,
    component: <Batch />,
    not_found_component: <Navigate to="/not_found" />,
    permission_denied_component: <Navigate to="/permission_denied" />,
  },
  {
    type: "open",
    name: "Invoice",
    key: "invoice",
    route: "/invoicing/invoice",
    // icon: <Icon fontSize="medium">description</Icon>,
    component: <Invoice />,
    requireRole: false,
    not_found_component: <Navigate to="/not_found" />,
    permission_denied_component: <Navigate to="/permission_denied" />,
  },
  {
    type: "open",
    name: "Recruitement Settings",
    key: "settings",
    route: "/recruitement/settings",
    requireRole: false,
    component: <SettingsRec />,
    not_found_component: <Navigate to="/not_found" />,
    permission_denied_component: <Navigate to="/permission_denied" />,
  },
  {
    type: "open",
    name: "Subscription payment",
    key: "SubscriptionPayment",
    route: "/invoicing/pricing_page/components/SubscriptionPayment",
    requireRole: false,
    component: <SubscriptionPayment />,
    not_found_component: <Navigate to="/not_found" />,
    permission_denied_component: <Navigate to="/permission_denied" />,
  },
  {
    type: "open",
    name: "Attendance Settings",
    key: "attendance_settings",
    permissionKey: "attendance",
    route: "/attendace/settings",
    requireRole: false,
    component: <AttendanceSettings />,
    modulePermissions: {
      office_shift_list_permission: "attendance | office shift|list",
      office_shift_create_permission: "attendance | office shift|create",
      office_shift_update_permission: "attendance | office shift|update",
      office_shift_delete_permission: "attendance | office shift|delete",
    },
    not_found_component: <Navigate to="/not_found" />,
    permission_denied_component: <Navigate to="/permission_denied" />,
  },
  {
    type: "open",
    name: "Leave Settings",
    key: "Leave_settings",
    permissionKey: "leave",
    route: "/leave/settings",
    requireRole: false,
    modulePermissions: {
      leave_type_list_permission: "leave | leave type|list",
      leave_type_create_permission: "leave | leave type|create",
      leave_type_update_permission: "leave | leave type|update",
      leave_type_delete_permission: "leave | leave type|delete",
    },
    component: <LeaveSettings />,
    not_found_component: <Navigate to="/not_found" />,
    permission_denied_component: <Navigate to="/permission_denied" />,
  },
  {
    type: "open",
    name: "Organisation Settings",
    permissionKey: ["organization", "attendance"],
    key: "organisation_settings",
    route: "/organisationSettings",
    requireRole: false,
    modulePermissions: {
      list_permission: "organization | organization|list",
      create_permission: "organization | organization|create",
      update_permission: "organization | organisation|update",
      delete_permission: "organization | organization|delete",
      department_list_permission: "organization | department|list",
      department_create_permission: "organization | department|create",
      department_update_permission: "organization | department|update",
      department_delete_permission: "organization | department|delete",
      designation_list_permission: "organization | designation|list",
      designation_create_permission: "organization | designation|create",
      designation_update_permission: "organization | designation|update",
      designation_delete_permission: "organization | designation|delete",
      role_list_permission: "organization | role|list",
      role_create_permission: "organization | role|create",
      role_delete_permission: "organization | role|delete",
      role_update_permission: "organization | role|update",
      documentType_list_permission: "organization | documentType|list",
      documentTyp__create_permission: "organization | documentType|create",
      documentType_update_permission: "organization | documentType|update",
      documentType_delete_permission: "organization | documentType|delete",
      tempcard_list_permission: "attendance | tem card|list",
      tempcard_owner_list_permission: "attendance | tem card|owner_list",
      tempcard_create_permission: "attendance | tem card|create",
      tempcard_update_permission: "attendance | tem card|update",
      tempcard_delete_permission: "attendance | tem card|delete",
    },
    component: <OrganisationSettings />,
    not_found_component: <Navigate to="/not_found" />,
    permission_denied_component: <Navigate to="/permission_denied" />,
  },
  {
    type: "open",
    name: "Employee Details",
    permissionKey: "employee",
    key: "Employee",
    route: "/employees/employee_view",
    requireRole: false,
    modulePermissions: {
      owner_list_permission: "employee | employee|owner_list",
      list_permission: "employee | employee|list",
      create_permission: "employee | employee|create",
      delete_permission: "employee | employee|delete",
      update_permission: "employee | employee|update",
      reporting_structure_owner_list_permission: "employee | reporting structure|owner_list",
      reporting_structure_list_permission: "employee | reporting structure|list",
      reporting_structure_update_permission: "employee | reporting structure|update",
      reporting_structure_create_permission: "employee | reporting structure|create",
      reporting_structure_delete_permission: "employee | reporting structure|delete",
      leave_balance_list_permission: "leave | leave balance|list",
      leave_balance_owner_list_permission: "leave | leave balance|owner_list",
      leave_balance_create_permission: "leave | leave balance|create",
      leave_balance_udpate_permission: "leave | leave balance|update",
    },
    component: <EmployeeView />,
    not_found_component: <Navigate to="/not_found" />,
    permission_denied_component: <Navigate to="/permission_denied" />,
  },
  {
    type: "sign",
    name: "Authentication",
    key: "authentication",
    icon: <Icon fontSize="medium">content_paste</Icon>,
    collapse: [
      {
        name: "Sign In",
        key: "sign-in",
        collapse: [
          {
            name: "Basic",
            key: "basic",
            route: "/authentication/sign-in/basic",
            component: <SignInBasic />,
          },
          {
            name: "Cover",
            key: "cover",
            route: "/authentication/sign-in/cover",
            component: <SignInCover />,
          },
          {
            name: "Illustration",
            key: "illustration",
            route: "/authentication/sign-in/illustration",
            component: <SignInIllustration />,

            requireRole: false,
            not_found_component: <Navigate to="/not_found" />,
            permission_denied_component: <Navigate to="/permission_denied" />,
          },
        ],
      },
      {
        name: "Sign Up",
        key: "sign-up",
        collapse: [
          {
            name: "OrgSignUp",
            key: "orgsignup",
            route: "/authentication/sign-up/organisation",

            requireRole: false,
            component: <OrganisationSignUp />,
            not_found_component: <Navigate to="/not_found" />,
            permission_denied_component: <Navigate to="/permission_denied" />,
          },
        ],
      },
      {
        name: "OTP",
        key: "otp",
        route: "/authentication/otp",
        component: <OTP />,
        // component: <SignUpIllustration />,
        not_found_component: <Navigate to="/not_found" />,
        permission_denied_component: <Navigate to="/permission_denied" />,
      },
      {
        name: "Reset Password",
        key: "reset-password",
        collapse: [
          {
            name: "Cover",
            key: "cover",
            route: "/authentication/reset-password/cover",
            component: <ResetCover />,
          },
        ],
      },
    ],
  },

  // {
  //   type: "collapse",
  //   name: "Marketing",
  //   key: "marketing",
  //   icon: <Icon fontSize="medium">file_copy</Icon>,
  //   collapse: [
  //     {
  //       name: "New Event",
  //       key: "newEvent",
  //       route: "/marketing/newEvent",
  //       requireRole: false,
  //       icon: <Icon fontSize="medium">receipt_long</Icon>,
  //       component: <NewEvent />,
  //       not_found_component: <Navigate to="/not_found" />,
  //       permission_denied_component: <Navigate to="/permission_denied" />,
  //     },
  //     {
  //       name: "Wizard",
  //       key: "wizard",
  //       route: "/applications/wizard",
  //       component: <Wizard />,
  //       not_found_component: <Navigate to="/not_found" />,
  //       permission_denied_component: <Navigate to="/permission_denied" />,
  //     },
  //   ],
  // },
  {
    type: "collapse",
    name: "Manager Desk",
    key: "manager",
    icon: <Icon fontSize="medium">check_circle</Icon>,
    collapse: [
      {
        name: "Approve Leave",
        key: "ApproveLeave",
        permissionKey: "leave",
        route: "manager/ApproveLeave",
        icon: <Icon fontSize="medium">check_circle</Icon>,
        requireRole: true,
        modulePermissions: {
          own_list_permission: "leave | leave request approval|owner_list",
          list_permission: "leave | leave request approval|list",
          create_permission: "leave | leave request approval|create",
          update_permission: "leave | leave request approval|update",
          delete_permission: "leave | leave request approval|delete",
        },
        // component: <ApproveLeave />,
        component: <ApproveLeaveTabs />,
        not_found_component: <Navigate to="/not_found" />,
        permission_denied_component: <Navigate to="/permission_denied" />,
      },
      {
        name: "Approve WFH",
        key: "ApproveWFH",
        permissionKey: "attendance",
        route: "manager/ApproveWFH",
        icon: <Icon fontSize="medium">home_work</Icon>,
        requireRole: true,
        modulePermissions: {
          own_list_permission: "attendance | work from home request|update",
          list_permission: "attendance | work from home request|update",
          create_permission: "attendance | work from home request|create",
          update_permission: "attendance | work from home request|update",
          delete_permission: "attendance | work from home request|delete",
        },
        component: <ApproveWFH />,
        not_found_component: <Navigate to="/not_found" />,
        permission_denied_component: <Navigate to="/permission_denied" />,
      },
      {
        name: "Shifts",
        key: "Shifts",
        permissionKey: "attendance",
        icon: <Icon fontSize="medium">access_time_filled</Icon>,
        route: "manager/Shifts",
        requireRole: true,
        modulePermissions: {
          own_list_permission: "attendance | employee shift|owner_list",
          list_permission: "attendance | employee shift|list",
          create_permission: "attendance | employee shift|create",
          update_permission: "attendance | employee shift|update",
          delete_permission: "attendance | employee shift|delete",
        },
        component: <Shifts />,
        not_found_component: <Navigate to="/not_found" />,
        permission_denied_component: <Navigate to="/permission_denied" />,
      },
      {
        name: "Approve MissPunch",
        key: "ApproveMissPunch",
        permissionKey: "attendance",
        icon: <Icon fontSize="medium">access_time</Icon>,
        route: "manager/ApproveMissPunch",
        requireRole: true,
        modulePermissions: {
          own_list_permission: "attendance | Employee Attendence|update",
          list_permission: "attendance | Employee Attendence|update",

        },
        component: <ApproveMissPunch />,
        not_found_component: <Navigate to="/not_found" />,
        permission_denied_component: <Navigate to="/permission_denied" />,
      },
      {
        name: "Upload Attendance",
        key: "UploadAttendance",
        permissionKey: "attendance",
        icon: <Icon fontSize="medium">access_time</Icon>,
        route: "/Attendance/UploadAttendance",
        requireRole: true,
        modulePermissions: {
          own_list_permission: "attendance | Employee Attendence|create",
          list_permission: "attendance | Employee Attendence|create",
          create_permission: "attendance | Employee Attendence|create",
          update_permission: "attendance | Employee Attendence|update",
          delete_permission: "attendance | Employee Attendence|delete",
        },
        component: <UploadAttendance />,
        not_found_component: <Navigate to="/not_found" />,
        permission_denied_component: <Navigate to="/permission_denied" />,
      },
    ]
  },
  {
    type: "header",
    name: "Payroll",
    key: "Payrole",
    permissionKey: "payrole",
    icon: <Icon fontSize="medium">assignment</Icon>, // Replace with your icon
    displayOnly: true, // Indicates no dropdown
    route: "/payroll/:tab", // Define the route path
    modulePermissions: {
      Payrole: {
        list_permission: "payrole | payrole|list",
        owner_list_permission: "payrole | payrole|owner_list",
        create_permission: "payrole | payrole|create",
        delete_permission: "payrole | payrole|delete",
        update_permission: "payrole | payrole|update",
      },
      Contracts: {
        list_permission: "payrole | employee contract|list",
        owner_list_permission: "payrole | employee contract|owner_list",
      },
      Expenses: {
        list_permission: "payrole | expense or incentive or deduction|list",
        owner_list_permission: "payrole | expense or incentive or deduction|owner_list",
        create_permission: "payrole | expense or incentive or deduction|create",
        update_permission: "payrole | expense or incentive or deduction|update",
        approve_permission: "payrole | expense or incentive or deduction|approve",
      },
      Salary: {
        list_permission: "payrole | employee salary|list",
        owner_list_permission: "payrole | employee salary|owner_list",
      },
      Batch: {
        list_permission: "payrole | salary batch|list",
        owner_list_permission: "payrole | salary batch|owner_list",
        view_permission: "payrole | salary batch|view",
        salary_list_permission: 'payrole | employee salary|list',
        salary_owner_list_permission: "payrole | employee salary|owner_list",
      },
      payroleSettings: {
        list_permission: "payrole | payrole|list",
        owner_list_permission: "payrole | payrole|owner_list",
        create_permission: "payrole | payrole|create",
        update_permission: "payrole | payrole|update",
        delete_permission: "payrole | payrole|delete",
        salary_head_list_permission: "payrole | salary head|list",
        salary_head_owner_list_permission: "payrole | salary head|owner_list",
        salary_head_create_permission: "payrole | salary head|create",
        salary_head_update_permission: "payrole | salary head|update",
        salary_head_delete_permission: "payrole | salary head|delete",
      }
    },
    component: <PayroleTabs />, // The component to render
    not_found_component: <Navigate to="/not_found" />,
    permission_denied_component: <Navigate to="/permission_denied" />,
  },
];

export default routes;
